module.exports = __webpack_public_path__ + "img/ManekiGames_icon-win.9a988afc.png";